import { forwardRef, useEffect, useState } from "react";
import { useConsent, isExternalUrl } from "../../../utils/cookieConsent";

type UserMenuTriggerProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  image: string | null | undefined;
  initials: string;
};

export const UserMenuTrigger = forwardRef<HTMLButtonElement, UserMenuTriggerProps>(
  function UserMenuTrigger({ image, initials, className, ...rest }, ref) {
    const consentAccepted = useConsent();
    const [imageBroken, setImageBroken] = useState(false);
    useEffect(() => {
      setImageBroken(false);
    }, [image]);
    const gatedByConsent = isExternalUrl(image) && !consentAccepted;
    const showImage = !!image && !imageBroken && !gatedByConsent;
    const merged = ["daynav-topbar__avatar", className].filter(Boolean).join(" ");
    return (
      <button
        ref={ref}
        type="button"
        data-testid="user-menu-trigger"
        aria-label="Open account menu"
        {...rest}
        className={merged}
      >
        {showImage ? (
          <img
            src={image!}
            alt=""
            className="daynav-topbar__avatar-img"
            onError={() => setImageBroken(true)}
          />
        ) : (
          <span className="daynav-topbar__avatar-initials" aria-hidden="true">
            {initials}
          </span>
        )}
      </button>
    );
  },
);
